//@ts-nocheck
import * as actionTypes from '../actions/actionTypes';

export const storeDetails = (prop, value) => ({
  prop,
  value,
  type: actionTypes.STORE_DETAILS,
});
